export default "__VITE_ASSET__DxIk0x3O__"